import React, { useContext } from 'react';
import {
  Button,
  Link,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Typography
} from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types';
import { PRIVACY_PATH } from '../../constants';
import { BannerContext } from '../../contexts/BannerContext';
import { TableDataShape } from '../../shapes/TableData';
import { updateSmsPreferences } from '../../apis/sms';

export const confirmModalButton = 'sms-confirm-modal-button';

function spacer() {
  return (
    <>
      <br />
      <br />
    </>
  );
}

function ConfirmationModal({
  phoneNumber, handleClose, handleOptInSuccess, tableData, selected, proLegalState, promoLegalState
}) {

  const { openErrorAlert } = useContext(BannerContext);

  const handleError = () => {
    openErrorAlert();
  };

  const handleConfirmConsent = () => {
    updateSmsPreferences(phoneNumber, selected, tableData, handleOptInSuccess, handleError);
  };

  function promoLegalText() {
    return (
      <>
        {`By providing your phone number and clicking "Confirm", you consent to The Home Depot
        contacting you at `}<b>65624</b>{` for The Home Depot promotional messages,
        including those sent using automated technology, SMS/MMS, and/or prerecorded, AI, or
        artificial messages. Consent is not required to make a purchase.
        Messaging frequency varies. Message and data rates may apply. Not all carriers are
        supported. For help, text HELP or call 1-800-466-3337; to stop,
        text STOP or call 1-800-553-3199. I understand that confirming this message constitutes
        as my signature. I further understand that my information will be used as described here
        and in The Home Depot’s `}
        <Link href={PRIVACY_PATH}>Privacy and Security Statement</Link>.

      </>
    );
  }

  function proLegalText() {
    return (
      <>
        {`By providing your phone number and clicking "Confirm", you consent to The Home Depot
        contacting you at `} <b>38688</b> {` for Pro marketing messages, including those sent using
        automated technology, SMS/MMS, and/or prerecorded, AI, or artificial messages. Consent
        is not required to make a purchase. Messaging frequency varies. Message and data rates may
        apply. Not all carriers are supported. For help, text HELP or call 1-800-466-3337; to stop,
        text STOP or call 1-800-553-3199. I understand that confirming this message constitutes as
        my signature. I further understand that my information will be used as described here and
        in The Home Depot’s `}
        <Link href={PRIVACY_PATH}>Privacy and Security Statement</Link>.

      </>
    );
  }

  function promoAndProLegalText() {
    return (
      <>
        {`By providing your phone number and clicking "Confirm", you consent to The Home Depot
        contacting you at `} <b>65624</b> {` or `} <b>38688</b> {` for The Home Depot promotional
        or Pro marketing messages, including those sent using automated technology, SMS/MMS,
        and/or prerecorded, AI, or artificial messages. Consent is not required to make a purchase.
        Messaging frequency varies. Message and data rates may apply. Not all carriers are
        supported. For help, text HELP or call 1-800-466-3337; to stop, text STOP or
        call 1-800-553-3199. I understand that confirming this message constitutes as my
        signature. I further understand that my information will be used as described here and
        in The Home Depot’s `}
        <Link href={PRIVACY_PATH}>Privacy and Security Statement</Link>.

      </>
    );
  }

  return (
    <Modal open onClose={handleClose}>
      <ModalHeader onClose={handleClose}>Confirm Your Consent</ModalHeader>
      <ModalBody>
        <Typography variant="body-base">
          {promoLegalState && !proLegalState && promoLegalText()}
          {proLegalState && !promoLegalState && proLegalText()}
          {promoLegalState && proLegalState && promoAndProLegalText()}
        </Typography>
      </ModalBody>
      <ModalFooter position="end">
        <Button aria-label={confirmModalButton} onClick={handleConfirmConsent}>
          Confirm
        </Button>
      </ModalFooter>
    </Modal>
  );
}

ConfirmationModal.propTypes = {
  phoneNumber: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleOptInSuccess: PropTypes.func.isRequired,
  tableData: TableDataShape.isRequired,
  selected: PropTypes.arrayOf(PropTypes.string).isRequired,
  proLegalState: PropTypes.bool.isRequired,
  promoLegalState: PropTypes.bool.isRequired,

};

export default ConfirmationModal;
